import dayjs from 'dayjs';
import { i18next } from '@frontend/i18n';
import { DaysOfWeek, FormConfig } from '@frontend/design-system';
import { AvailabilityScheduleType, BookingInterval } from '../../types/availability-rules.types';
import { TIME_UNIT_OPTIONS } from './constants';

const today = dayjs().format('YYYY-MM-DD');

const validateDaysOfWeek = ({ value }: { value: string[] }) => {
  if (!value || value.length === 0) {
    return i18next.t('Select a day of the week', { ns: 'schedule-settings' });
  }
  return '';
};

export const availabilityRulesFields = {
  recurrence: {
    type: 'dropdown',
    required: true,
    value: AvailabilityScheduleType.WEEKLY,
  },
  interval: {
    type: 'dropdown',
    required: true,
    value: '1',
  },
  timeUnit: {
    type: 'dropdown',
    required: true,
    value: TIME_UNIT_OPTIONS[0].value,
  },
  daysOfWeek: {
    type: 'multiselect',
    required: true,
    value: [] as DaysOfWeek[],
    validator: validateDaysOfWeek,
    validateOnChange: true,
  },
  startDate: {
    type: 'datePicker',
    value: '',
    required: false,
    minDate: today,
  },
  startTime: {
    type: 'time',
    required: true,
    value: '',
  },
  endTime: {
    type: 'time',
    required: true,
    value: '',
  },
  provider: {
    type: 'dropdown',
    required: true,
    value: '',
  },
  appointmentTypes: {
    type: 'checklist',
    required: true,
    minRequired: 1,
    value: [],
  },
  bookingCadence: {
    type: 'dropdown',
    required: true,
    value: BookingInterval.NONE,
  },
} satisfies FormConfig;

export type AvailabilityRulesFieldTypes = typeof availabilityRulesFields;
